import React from 'react';
import { Box, Text } from '@mantine/core';
import { useTranslations } from 'next-intl';
import MapContainer from '../MapContainer';

export interface LocationData {
  formattedAddress: string;
  coordinates: { lat: number; lng: number };
  detailedAddress: {
    street: string;
    apartment: string;
    emirate: string;
  };
}

interface LocationStepProps {
  location: LocationData | null;
  onLocationChange: (location: LocationData) => void;
}

const LocationStep: React.FC<LocationStepProps> = ({ location, onLocationChange }) => {
  const t = useTranslations('locationStep');

  return (
    <Box>
      <Text size="lg" mb="md">
        {t('selectedLocationText')}
      </Text>
      <MapContainer
        location={location}
        setLocation={onLocationChange}
        initialCenter={{ lat: 25.197197, lng: 55.274376 }} // Burj Khalifa coordinates
        defaultZoom={18}
        countriesRestriction={['AE']}
      />
      <Text mt="md">
        {t('selectedLocationText')}: {location ? location.formattedAddress : t('notSelected')}
      </Text>
    </Box>
  );
};

export default LocationStep;
